import { ReactNode, FC } from "react";

import Button from "../../../components/Desktop/Button";

const ResourceHow = () => {
  return (
    <section className="pr-[120px] h-[1130px]">
      <div className="relative w-full h-full">
        {/* First Row */}
        <div className="scroll-mt-[90px]" id="resource-how">
          <div className="w-[559px] h-[203px] bg-primaryDark-400 flex items-center justify-center">
            <h3 className="text-[36px] font-raleway font-semibold text-text-1000">
              How Does It Work?
            </h3>
          </div>
        </div>

        {/* Second Row */}
        <div className="bg-text-1000 border border-[#E9E9E9] rounded-[24px] absolute z-2 top-[140px] right-[70px] p-[50px]">
          {/* Cards */}
          <div className="grid grid-cols-2 grid-rows-2 gap-[24px] mb-[24px]">
            {/* Card One */}
            <ResourceHowCard
              step={1}
              heading={<>Complete Your Profile</>}
              description={
                <>
                  Sign up with HomeCook and showcase <br />
                  your unique offerings and charm.
                </>
              }
            />

            {/* Card Two */}
            <ResourceHowCard
              step={2}
              heading={
                <>
                  Preview Booking <br /> Requests
                </>
              }
              description={
                <>
                  Receive booking requests from pre-vetted <br />
                  food entrepreneurs.
                </>
              }
            />

            {/* Card Three */}
            <ResourceHowCard
              step={3}
              heading={<>Control Your Availability</>}
              description={
                <>
                  Tailor open calendar slots based on your <br />
                  availability.
                </>
              }
            />

            {/* Card Four */}
            <ResourceHowCard
              step={4}
              heading={
                <>
                  Coordinate with <br /> Clients
                </>
              }
              description={
                <>
                  Directly communicate through HomeCook <br />
                  to coordinate logistics.
                </>
              }
            />
            {/* Card Five */}
            <ResourceHowCard
              step={5}
              heading={
                <>
                  Track Usage and <br /> Payments
                </>
              }
              description={
                <>
                  Manage bookings & receive payments all in <br />
                  real-time through our app.
                </>
              }
            />
          </div>

          {/* Button */}
          <div className="scroll-mt-[100px]" id="resource-how-box">
            <Button label="Watch Tutorials" variant="secondary" onClick={() => window.open("https://site.homecookapp.com/kitchen-dashboard-step-categories", "_blank")} />
          </div>
        </div>
      </div>
    </section>
  );
};

type ResourceHowCardProps = {
  step: number;
  heading: ReactNode;
  description: ReactNode;
};

const ResourceHowCard: FC<ResourceHowCardProps> = ({
  step,
  heading,
  description,
}) => {
  return (
    <div className="border-[2px] border-dashed border-[#E9E9E9] rounded-[16px] p-[30px]">
      {/* Header */}
      <div className="flex items-center gap-[16px] mb-[16px]">
        <p className="text-[96px] font-raleway text-[#F5F5F5] leading-none">
          {step}
        </p>
        <h4 className="text-[24px] font-raleway font-semibold text-primaryDark-0 leading-tight">
          {heading}
        </h4>
      </div>

      <p className="text-[16px] font-open-sans text-text-0 leading-loose">
        {description}
      </p>
    </div>
  );
};

export default ResourceHow;
